export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = reject;
    reader.onload = (event) => {
      const dataUrl = event.target.result;
      // Will ignore the "data:*/*;base64," piece
      const base64 = dataUrl.substr(dataUrl.indexOf(',') + 1);

      resolve({
        dataUrl,
        base64,
        file,
        name: file.name,
        type: file.type,
        size: file.size,
      });
    };

    reader.readAsDataURL(file);
  });
};

export const readFilesAsBase64 = (files) => {
  if (!files.length) {
    return Promise.resolve([]);
  }

  return new Promise((resolve) => {
    const base64Files = files.map((file) => fileToBase64(file));

    Promise.all(base64Files).then((result) => resolve(result));
  });
};
